import { Box, Image, ModBox, Spacer, useWindowDimensions } from '@jfs/ui-new'
import { useState } from 'react'
import { ScrollView } from 'react-native'
import Footer from '../../comps/Footer'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { isMobileWidth } from '../../util/util'
import { About } from './About'
import { Header } from './Header'
import { JioBizz } from './JioBizz'
import { JioPayForBharat } from './JioPayForBharat'
import { PayAnyOneAnyWhere } from './PayAnyOneAnyWhere'
import { RechargeAndPayBillSection } from './RechargeAndPayBillSection'
import { Rewards } from './Rewards'
import { SafeSecureSection } from './SafeSecureSection'
import { SafetyAndSecurity } from './SafetyAndSecurity'
import { ShopAnywhere } from './ShopAnywhere'
import { Statistics } from './Statistics'
import { WhyUseJioPay } from './WhyUseJioPay'

const JioPayConsumers = () => {
  const viewportWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewportWidth)

  const [payAnyWhereOffset, setPayAnyWhereOffset] = useState(-1)
  const [payAnyWhereHeight, setPayAnyWhereHeight] = useState(-1)
  const [expandAnimation, setExpandAnimation] = useState(false)
  const [collapseAnimation, setCollapseAnimation] = useState(false)
  const [scrollOffset, setScrollOffset] = useState(-1)

  const [rewardsOffset, setRewardsOffset] = useState(-1)
  const [rewardsHeight, setRewardsHeight] = useState(-1)
  const [rewardsExpandAnimation, setRewardsExpandAnimation] = useState(false)
  const [rewardCollapseAnimation, setRewardsCollapseAnimation] = useState(false)

  const [basketOffset, setBasketOffset] = useState(-1)
  const [basketHeight, setBasketHeight] = useState(-1)
  const [basketMoveOutAnimation, setBasketMoveOutAnimation] = useState(false)
  const [basketMoveInAnimation, setBasketMoveInAnimation] = useState(false)

  const handlePayAnyWhereAnimation = (evt: any, isMovingUp: boolean) => {
    if (isMovingUp) {
      if (
        !expandAnimation &&
        payAnyWhereOffset + payAnyWhereHeight / 2 - evt?.nativeEvent?.contentOffset?.y <=
          evt?.nativeEvent?.layoutMeasurement?.height &&
        payAnyWhereOffset + payAnyWhereHeight / 2 - evt?.nativeEvent?.contentOffset?.y >
          evt?.nativeEvent?.layoutMeasurement?.height / 2
      ) {
        setExpandAnimation(true)
        setCollapseAnimation(false)
      }
      const bufferVal = isMobile ? 0 : payAnyWhereHeight
      if (!collapseAnimation && payAnyWhereOffset + bufferVal - evt?.nativeEvent?.contentOffset?.y < 0) {
        setExpandAnimation(false)
      }
    } else {
      if (
        !expandAnimation &&
        payAnyWhereOffset + payAnyWhereHeight - evt?.nativeEvent?.contentOffset?.y >
          evt?.nativeEvent?.layoutMeasurement?.height
      ) {
        setCollapseAnimation(true)
        setExpandAnimation(false)
        return
      } else {
        setCollapseAnimation(false)
        setExpandAnimation(false)
      }
      if (
        !collapseAnimation &&
        payAnyWhereOffset + payAnyWhereHeight / 2 - evt?.nativeEvent?.contentOffset?.y <=
          evt?.nativeEvent?.layoutMeasurement?.height &&
        payAnyWhereOffset + payAnyWhereHeight - evt?.nativeEvent?.contentOffset?.y <
          evt?.nativeEvent?.layoutMeasurement?.height / 2
      ) {
        setCollapseAnimation(false)
      } else {
        setExpandAnimation(false)
        setCollapseAnimation(false)
      }
    }
  }

  const handleBasketAnimation = (evt: any, isMovingUp: boolean) => {
    if (isMovingUp) {
      const bufferH = isMobile ? -16 : basketHeight / 2
      if (
        !basketMoveOutAnimation &&
        basketOffset + 48 - evt?.nativeEvent?.contentOffset?.y <= evt?.nativeEvent?.layoutMeasurement?.height &&
        basketOffset + 48 - evt?.nativeEvent?.contentOffset?.y > 0
      ) {
        setBasketMoveOutAnimation(true)
        setBasketMoveInAnimation(false)
      }
      if (!basketMoveInAnimation && basketOffset + bufferH - evt?.nativeEvent?.contentOffset?.y < 0) {
        setBasketMoveOutAnimation(false)
      }
    } else {
      const bufferH = isMobile ? basketHeight / 2 : basketHeight

      if (
        !basketMoveOutAnimation &&
        basketOffset + bufferH - evt?.nativeEvent?.contentOffset?.y > evt?.nativeEvent?.layoutMeasurement?.height
      ) {
        setBasketMoveInAnimation(true)
        setBasketMoveOutAnimation(false)
        return
      } else {
        setBasketMoveInAnimation(false)
        setBasketMoveOutAnimation(false)
      }
      if (
        !basketMoveInAnimation &&
        basketOffset + bufferH - evt?.nativeEvent?.contentOffset?.y > 0 &&
        basketOffset + bufferH - evt?.nativeEvent?.contentOffset?.y < evt?.nativeEvent?.layoutMeasurement?.height
      ) {
        setBasketMoveInAnimation(false)
      } else {
        setBasketMoveOutAnimation(false)
        setBasketMoveInAnimation(false)
      }
    }
  }

  const handleRewardsAnimation = (evt: any, isMovingUp: boolean) => {
    if (isMovingUp) {
      const bufferH = isMobile ? 120 : 60
      if (
        !rewardCollapseAnimation &&
        rewardsOffset + rewardsHeight - bufferH - evt?.nativeEvent?.contentOffset?.y <=
          evt?.nativeEvent?.layoutMeasurement?.height &&
        rewardsOffset + rewardsHeight - bufferH - evt?.nativeEvent?.contentOffset?.y > 0
      ) {
        setRewardsExpandAnimation(true)
        setRewardsCollapseAnimation(false)
      } else {
        setRewardsExpandAnimation(false)
        setRewardsCollapseAnimation(false)
      }
      if (!rewardCollapseAnimation && rewardsOffset + rewardsHeight / 2 - evt?.nativeEvent?.contentOffset?.y < 0) {
        setRewardsExpandAnimation(false)
      }
    } else {
      if (
        !rewardsExpandAnimation &&
        rewardsOffset + rewardsHeight - 100 - evt?.nativeEvent?.contentOffset?.y >
          evt?.nativeEvent?.layoutMeasurement?.height
      ) {
        setRewardsCollapseAnimation(true)
        setRewardsExpandAnimation(false)
        return
      } else {
        setRewardsCollapseAnimation(false)
        setRewardsExpandAnimation(false)
      }
      if (
        !rewardCollapseAnimation &&
        rewardsOffset + rewardsHeight - 100 - evt?.nativeEvent?.contentOffset?.y > 0 &&
        rewardsOffset + rewardsHeight - 100 - evt?.nativeEvent?.contentOffset?.y <
          evt?.nativeEvent?.layoutMeasurement?.height
      ) {
        setRewardsCollapseAnimation(false)
      } else {
        setRewardsExpandAnimation(false)
        setRewardsCollapseAnimation(false)
      }
    }
  }
  const onScroll = (evt: any) => {
    if (scrollOffset === evt?.nativeEvent?.contentOffset?.y) {
      return
    }
    const isMovingUp = evt?.nativeEvent?.contentOffset?.y - scrollOffset > 0

    handlePayAnyWhereAnimation(evt, isMovingUp)
    handleRewardsAnimation(evt, isMovingUp)
    handleBasketAnimation(evt, isMovingUp)
    setScrollOffset(evt?.nativeEvent?.contentOffset?.y)
  }
  return (
    <Box bg={'WHITE'} h={'100vh'}>
      <ScrollView onScroll={onScroll} scrollEventThrottle={16} showsVerticalScrollIndicator={false}>
        <LinearGradientContainer
          colorArray={['#000092', '#1634A0']}
          useAngle={true}
          angle={299}
          customStyle={{ height: isMobile ? 640 : '100vh' }}>
          <Box f={1}>
            <ModBox position={'absolute'} top={-148} left={isMobile ? 150 : -150} show={!isMobile}>
              <Image
                source={require('../../assets/svg/dots-pattern1.svg')}
                height={isMobile ? 400 : 300}
                width={isMobile ? 400 : 300}
              />
            </ModBox>
            <Box
              position={'absolute'}
              top={isMobile ? -200 : -80}
              left={isMobile ? 150 : viewportWidth - 400 + 50}
              w={350}
              overflow={'hidden'}>
              <Image
                source={require('../../assets/svg/dots-pattern2.svg')}
                height={400}
                width={400}
                resizeMode={'contain'}
              />
            </Box>
            <Header />
            <Spacer size={24} />
            <SafeSecureSection />
          </Box>
        </LinearGradientContainer>
        <JioPayForBharat />
        <PayAnyOneAnyWhere
          collapseAnimation={collapseAnimation}
          expandAnimation={expandAnimation}
          setPayAnyWhereOffset={setPayAnyWhereOffset}
          setPayAnyWhereHeight={setPayAnyWhereHeight}
        />
        <ShopAnywhere
          setBasketOffset={setBasketOffset}
          setBasketHeight={setBasketHeight}
          basketHeight={basketHeight}
          moveInAnimation={basketMoveInAnimation}
          moveOutAnimation={basketMoveOutAnimation}
        />
        <RechargeAndPayBillSection />
        <Rewards
          collapseAnimation={rewardCollapseAnimation}
          expandAnimation={rewardsExpandAnimation}
          setRewardsOffset={setRewardsOffset}
          setRewardsHeight={setRewardsHeight}
        />
        <SafetyAndSecurity />
        <Statistics />
        <JioBizz />
        <About />
        <WhyUseJioPay />
        <Box>
          <Footer type={'consumer'} />
        </Box>
      </ScrollView>
    </Box>
  )
}

export default JioPayConsumers
